import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import ScrollToTop from "@/components/feature/ScrollToTop";
import SEO from "@/components/feature/SEO";
import SchemaOrg from "@/components/feature/SchemaOrg";
import HeroSection from "./components/HeroSection";
import FeatureSection from "./components/FeatureSection";
import HotComics from "./components/HotComics";
import CategoryGrid from "./components/CategoryGrid";
import LatestUpdates from "./components/LatestUpdates";
import DownloadCTA from "./components/DownloadCTA";
import FAQSection from "./components/FAQSection";

export default function Home() {
  return (
    <>
      <ScrollToTop />
      <SEO
        title="51漫画 | 51漫画免费下载与免费版下载APP下载 - 漫画资源大全免费全集离线阅读手机客户端安装"
        description="51漫画下载资源页面，提供51漫画免费下载、免费版下载与APP下载，海量漫画全集免费离线阅读，支持手机客户端安装，随时随地畅享漫画阅读。51漫画网站涵盖热血、恋爱、搞笑、冒险等全类型漫画资源。"
        keywords="51漫画下载,51漫画免费下载,51漫画免费版下载,51漫画APP下载,离线漫画,免费漫画下载,漫画全集下载,客户端下载,漫画下载大全,51漫画网站"
        canonicalUrl="https://www.51manhua.com/"
      />
      <SchemaOrg
        type="WebPage"
        data={{
          name: "51漫画首页",
          description: "51漫画免费下载与免费版下载APP下载 - 漫画资源大全免费全集离线阅读手机客户端安装",
          url: "https://www.51manhua.com/",
          isPartOf: {
            "@type": "WebSite",
            name: "51漫画",
            url: "https://www.51manhua.com/",
          },
        }}
      />
      <SchemaOrg
        type="FAQPage"
        data={{
          mainEntity: [
            {
              "@type": "Question",
              name: "51漫画APP是免费下载的吗？",
              acceptedAnswer: {
                "@type": "Answer",
                text: "是的，51漫画APP完全免费下载使用。我们提供海量免费漫画资源，无需付费即可畅享阅读体验。",
              },
            },
            {
              "@type": "Question",
              name: "51漫画支持离线阅读吗？",
              acceptedAnswer: {
                "@type": "Answer",
                text: "支持！51漫画APP支持全集离线下载阅读，无网络也能随时阅读。",
              },
            },
            {
              "@type": "Question",
              name: "51漫画免费版下载和APP下载有什么区别？",
              acceptedAnswer: {
                "@type": "Answer",
                text: "免费版下载指网页端直接阅读，APP下载指在手机客户端安装51漫画应用，APP客户端提供更流畅的阅读体验和离线下载功能。",
              },
            },
            {
              "@type": "Question",
              name: "51漫画的漫画资源更新频率如何？",
              acceptedAnswer: {
                "@type": "Answer",
                text: "漫画资源每日更新，热门连载漫画通常会在原作发布后24小时内完成更新。",
              },
            },
          ],
        }}
      />

      <div className="min-h-screen bg-background-50">
        <Navbar />
        <main>
          <HeroSection />
          <FeatureSection />
          <HotComics />
          <CategoryGrid />
          <LatestUpdates />
          <DownloadCTA />
          <FAQSection />
        </main>
        <Footer />
      </div>
    </>
  );
}